import { toast } from "react-toastify";
import Close from "@mui/icons-material/Close";
import AlertLegalbird from "@/src/components/legalbird/AlertLegalbird/AlertLegalbird.tsx";
import AlertContentLegalbird from "@/src/components/legalbird/AlertLegalbird/AlertContentLegalbird.tsx";
import { actionsStyle } from "./actionsStyle.ts";

type addMessageProps = {
  type: "success" | "error" | "info" | "warning";
  text: string;
};

export function addMessage({ type, text }: addMessageProps) {
  toast[type](
    () => {
      return (
        <AlertLegalbird severity={type} sx={actionsStyle.alert}>
          <AlertContentLegalbird subtitle={text} />
        </AlertLegalbird>
      );
    },
    {
      icon: false,
      closeButton: () => (
        <Close
          color={type}
          sx={{
            position: "absolute",
            right: "1rem",
          }}
        />
      ),
    },
  );
}
